import { TextField } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import React from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

const DateFrom = ({ dateFrom, setDateFrom, label }) => {
  const handleChange = (newValue) => {
    const dateFromString = newValue
    const dateFromData = new Date(dateFromString)
    const dayFrom = dateFromData.getDate().toString().padStart(2, '0')
    const monthFrom = (dateFromData.getMonth() + 1).toString().padStart(2, '0')
    const yearFrom = dateFromData.getFullYear()
    const convertedDateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`
    setDateFrom(convertedDateFrom)
  }

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          inputFormat="DD/MM/YYYY"
          componentsProps={{
            actionBar: { actions: ['clear', 'today'] },
          }}
          value={dateFrom}
          onChange={handleChange}
          renderInput={(params) => <TextField {...params} label={label ?? 'Date From'} size="small" fullWidth />}
        />
      </LocalizationProvider>
    </>
  )
}

export default DateFrom
